// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/customer_contract_csv_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExportCustomerContractsRow, ImportCustomerContractsRowResult, ImportCustomerContractsSummary } from "./customer_contract_csv_model_pb";
import { file_bffuser_v1_customer_contract_csv_model } from "./customer_contract_csv_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/customer_contract_csv_service.proto.
 */
export const file_bffuser_v1_customer_contract_csv_service: GenFile = /*@__PURE__*/
  fileDesc("Ci5iZmZ1c2VyL3YxL2N1c3RvbWVyX2NvbnRyYWN0X2Nzdl9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxInMKHkltcG9ydEN1c3RvbWVyQ29udHJhY3RzUmVxdWVzdBIdCgdjb250ZW50GAEgASgMQgy6SAl6BxABGICAgAoSDwoHZHJ5X3J1bhgCIAEoCBIhCg1jc3ZfZmlsZV9uYW1lGAMgASgJQgq6SAdyBRABGP8BIrIBCh9JbXBvcnRDdXN0b21lckNvbnRyYWN0c1Jlc3BvbnNlEg8KB2FwcGxpZWQYASABKAgSQQoLcm93X3Jlc3VsdHMYAiADKAsyLC5iZmZ1c2VyLnYxLkltcG9ydEN1c3RvbWVyQ29udHJhY3RzUm93UmVzdWx0EjsKB3N1bW1hcnkYAyABKAsyKi5iZmZ1c2VyLnYxLkltcG9ydEN1c3RvbWVyQ29udHJhY3RzU3VtbWFyeSIgCh5FeHBvcnRDdXN0b21lckNvbnRyYWN0c1JlcXVlc3QipQEKH0V4cG9ydEN1c3RvbWVyQ29udHJhY3RzUmVzcG9uc2USNAoEcm93cxgBIAMoCzImLmJmZnVzZXIudjEuRXhwb3J0Q3VzdG9tZXJDb250cmFjdHNSb3cSOAoPZGF0YV91cGRhdGVkX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQhIKEF9kYXRhX3VwZGF0ZWRfYXQyhAIKGkN1c3RvbWVyQ29udHJhY3RDc3ZTZXJ2aWNlEnIKF0ltcG9ydEN1c3RvbWVyQ29udHJhY3RzEiouYmZmdXNlci52MS5JbXBvcnRDdXN0b21lckNvbnRyYWN0c1JlcXVlc3QaKy5iZmZ1c2VyLnYxLkltcG9ydEN1c3RvbWVyQ29udHJhY3RzUmVzcG9uc2UScgoXRXhwb3J0Q3VzdG9tZXJDb250cmFjdHMSKi5iZmZ1c2VyLnYxLkV4cG9ydEN1c3RvbWVyQ29udHJhY3RzUmVxdWVzdBorLmJmZnVzZXIudjEuRXhwb3J0Q3VzdG9tZXJDb250cmFjdHNSZXNwb25zZUJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bffuser_v1_customer_contract_csv_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * @generated from message bffuser.v1.ImportCustomerContractsRequest
 */
export type ImportCustomerContractsRequest = Message<"bffuser.v1.ImportCustomerContractsRequest"> & {
  /**
   * CSV の生バイト列 (UTF-8 BOM / UTF-8 / Shift_JIS)。
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * true = プレビュー、false = 確定。
   *
   * @generated from field: bool dry_run = 2;
   */
  dryRun: boolean;

  /**
   * 取込履歴に記録する CSV ファイル名。
   *
   * @generated from field: string csv_file_name = 3;
   */
  csvFileName: string;
};

/**
 * Describes the message bffuser.v1.ImportCustomerContractsRequest.
 * Use `create(ImportCustomerContractsRequestSchema)` to create a new message.
 */
export const ImportCustomerContractsRequestSchema: GenMessage<ImportCustomerContractsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_contract_csv_service, 0);

/**
 * @generated from message bffuser.v1.ImportCustomerContractsResponse
 */
export type ImportCustomerContractsResponse = Message<"bffuser.v1.ImportCustomerContractsResponse"> & {
  /**
   * @generated from field: bool applied = 1;
   */
  applied: boolean;

  /**
   * @generated from field: repeated bffuser.v1.ImportCustomerContractsRowResult row_results = 2;
   */
  rowResults: ImportCustomerContractsRowResult[];

  /**
   * @generated from field: bffuser.v1.ImportCustomerContractsSummary summary = 3;
   */
  summary?: ImportCustomerContractsSummary;
};

/**
 * Describes the message bffuser.v1.ImportCustomerContractsResponse.
 * Use `create(ImportCustomerContractsResponseSchema)` to create a new message.
 */
export const ImportCustomerContractsResponseSchema: GenMessage<ImportCustomerContractsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_contract_csv_service, 1);

/**
 * @generated from message bffuser.v1.ExportCustomerContractsRequest
 */
export type ExportCustomerContractsRequest = Message<"bffuser.v1.ExportCustomerContractsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ExportCustomerContractsRequest.
 * Use `create(ExportCustomerContractsRequestSchema)` to create a new message.
 */
export const ExportCustomerContractsRequestSchema: GenMessage<ExportCustomerContractsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_contract_csv_service, 2);

/**
 * @generated from message bffuser.v1.ExportCustomerContractsResponse
 */
export type ExportCustomerContractsResponse = Message<"bffuser.v1.ExportCustomerContractsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.ExportCustomerContractsRow rows = 1;
   */
  rows: ExportCustomerContractsRow[];

  /**
   * @generated from field: optional google.protobuf.Timestamp data_updated_at = 2;
   */
  dataUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ExportCustomerContractsResponse.
 * Use `create(ExportCustomerContractsResponseSchema)` to create a new message.
 */
export const ExportCustomerContractsResponseSchema: GenMessage<ExportCustomerContractsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_contract_csv_service, 3);

/**
 * CustomerContractCsvService は顧客契約 CSV の取込とダウンロードを扱う
 * (docs/specs/admin/data/uploads/customer-contract.md)。organization_id と
 * acting_member_id は露出させず BFF が eauth セッションから補完する (multitenant.md)。
 * internalapi.v1.CustomerContractCsvService の薄い pass-through。
 *
 * @generated from service bffuser.v1.CustomerContractCsvService
 */
export const CustomerContractCsvService: GenService<{
  /**
   * ImportCustomerContracts は顧客契約 CSV を検証・反映する (dry_run=true でプレビュー)。
   *
   * @generated from rpc bffuser.v1.CustomerContractCsvService.ImportCustomerContracts
   */
  importCustomerContracts: {
    methodKind: "unary";
    input: typeof ImportCustomerContractsRequestSchema;
    output: typeof ImportCustomerContractsResponseSchema;
  },
  /**
   * ExportCustomerContracts は削除されていない全地点 (見込み・失注を含む) を 1 地点 1 行で返す。
   *
   * @generated from rpc bffuser.v1.CustomerContractCsvService.ExportCustomerContracts
   */
  exportCustomerContracts: {
    methodKind: "unary";
    input: typeof ExportCustomerContractsRequestSchema;
    output: typeof ExportCustomerContractsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_customer_contract_csv_service, 0);

